import { useEventListener } from '@vueuse/core'
import { defineStore } from 'pinia'
import { ref } from 'vue'

// Remembers whether the user last touched the keyboard or the mouse, because the browser cannot tell us that when focus is moved by code (it guesses, and often guesses keyboard after a click!)
export const useInputModalityStore = defineStore('inputModality', () => {
  const lastInputWasKeyboard = ref(false)

  // Capture phase so a component that stops propagation cannot hide the event.
  useEventListener(
    document,
    'keydown',
    () => (lastInputWasKeyboard.value = true),
    { capture: true }
  )
  useEventListener(
    document,
    'pointerdown',
    () => (lastInputWasKeyboard.value = false),
    { capture: true }
  )

  return { lastInputWasKeyboard }
})
